import React, { useState } from "react";
import { auth } from "../firebase";
import { useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";

const PaymentRequired = () => {
  const [loading, setLoading] = useState(false);
  const [params] = useSearchParams();
  const [schoolId, setSchoolId] = useState(null);
  useEffect(() => {
    const paramSchoolId = params.get("schoolId");

    if (paramSchoolId) {
      setSchoolId(paramSchoolId);
      return;
    }

    const fetchSchool = async () => {
      const user = auth.currentUser;
      if (!user) return;

      const docSnap = await getDoc(doc(db, "users", user.uid));
      if (docSnap.exists()) {
        setSchoolId(docSnap.data().schoolId);
      }
    };

    fetchSchool();
  }, []);
  const handleCheckout = async () => {
    try {
      setLoading(true);

      const user = auth.currentUser;
      if (!user) {
        alert("You must be logged in.");
        return;
      }

      const idToken = await user.getIdToken();
      if (!schoolId) {
        alert("Missing school information. Please log in again.");
        return;
      }

      // 🔥 call your existing Stripe function
      const response = await fetch(
        "https://us-central1-pbis-app-72ba5.cloudfunctions.net/createCheckoutSession",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${idToken}`,
          },
          body: JSON.stringify({
            email: user.email,
            schoolId: schoolId
          }),
        }
      );

      const data = await response.json();

      if (!response.ok || !data.url) {
        throw new Error(data.error || "Failed to start checkout");
      }

      window.location.href = data.url;
    } catch (err) {
      console.error(err);
      alert("Failed to start payment");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ textAlign: "center", marginTop: "4rem" }}>
      <h1>💳 Payment Required</h1>
      <p>Your school account is not yet activated.</p>
      <p>Please complete payment to continue.</p>

      <button
        onClick={handleCheckout}
        disabled={loading || !schoolId}
        style={{
          marginTop: "1.5rem",
          backgroundColor: "#10b981",
          color: "#fff",
          border: "none",
          padding: "0.8rem 1.2rem",
          borderRadius: "8px",
          fontWeight: 700,
          cursor: "pointer",
        }}
      >
        {loading ? "Redirecting..." : "💳 Complete Payment"}
      </button>
    </div>
  );
};

export default PaymentRequired;